<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="绑定租赁方案"
    :width="'824px'"
    :append-to-body="true"
    :destory-on-close="true"
    :before-close="cancelHandle"
    @open="handleInitial"
  >
    <div class="bindPlan_tips">
      <div>
        <span>提示:</span
        >提交维保项目和指定租赁方案绑定关系后，可以前往"车辆-维保管理-租赁方案绑定纪录"中查看
      </div>
      <div><span>租赁方案所属公司:</span>{{ userInfo.tenantName }}</div>
      <div><span>维保项目:</span>{{ planRow.itemName }}</div>
      <div><span>维修厂:</span>{{ planRow.usableStoreNameList }}</div>
    </div>
    <el-form :model="formData" width="80%">
      <el-form-item label="租赁方案类型:">
        <el-select
          v-model="formData.rentPlanType"
          placeholder="请选择"
          @change="handlePlanChange"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="item in rentPlanTypes"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择租赁方案:" class="selectPlan-container">
        <div class="selectPlan-box">
          <QS-select
            remote
            :remote-method="remoteMethod"
            v-model="formData.planIds"
            multiple
            placeholder="请选择"
            filterable
            :loading="loading"
            class="selectPlan"
            @clear="handleClear"
            @change="handlePlanIdsChange"
          >
            <QS-option
              v-for="item in planIds"
              :label="item.name + '-' + item.id"
              :value="item.id"
              :key="item.id"
            ></QS-option>
          </QS-select>
        </div>
        <el-button type="primary" @click="handleSelectAll">{{
          !isAll ? '选择全部' : '取消全部'
        }}</el-button>
      </el-form-item>
    </el-form>

    <el-table
      width="80%"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="name" label="租赁方案名称"> </el-table-column>
      <el-table-column prop="name" label="选择付款账户">
        <template slot-scope="scope">
          <el-form :model="scope.row" label="" :ref="`form${scope.row.id}`">
            <el-form-item
              prop="accountId"
              :rules="[
                {
                  required: true,
                  message: '请选择付款账户',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="scope.row.accountId"
                clearable
                filterable
                placeholder="请选择"
                class="resetopions"
                @change="
                  (accountId) => handleAccountChange(accountId, scope.row)
                "
              >
                <el-option
                  v-for="item in subAccountOptions"
                  :key="item.accountId"
                  :label="item.merchantName"
                  :value="item.accountId"
                >
                  <div class="selectPlan-item">
                    <TextOverTooltip :content="item.merchantName" placement="top" />
                    <TextOverTooltip :content="item.bankCardNo" placement="top"/>
                    <TextOverTooltip :content="item.bankShortName" placement="top"/>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer">
      <div class="mt16" style="text-align: center">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button type="primary" size="small" @click="handleOK"
          >提交</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getRentPlanListAPi,
  createItemRentPlanLinkApi,
} from '../../services/index'
import { getSubAccountList } from '@/api/domain/finance'
import config from './config'
import { mapGetters } from 'vuex'
import { unique } from '@/utils'

export default {
  name: 'bindSchemeDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    planRow: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const { rentPlanTypes } = config.call(this)
    return {
      isAll: false,
      loading: false,
      formData: {},
      rentPlanTypes,
      planIds: [],
      tableData: [],
      ids: [],
      isAbnormal: false,
      abnormalData: [],
      subAccountOptions: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    'formData.planIds': {
      deep: true,
      handler(newValue) {
        const _tabdata = []
        for (let i = 0; i < this.planIds.length; i++) {
          for (let j = 0; j < newValue.length; j++) {
            if (this.planIds[i].id === newValue[j]) {
              _tabdata.push(this.planIds[i])
            }
          }
        }
        this.tableData = unique([...this.tableData, ..._tabdata], 'id')
        this.$nextTick(() => {
          this.tableData.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          })
        })
      },
    },
  },
  methods: {
    getSubAccountList() {
      getSubAccountList({
        accountType: 2,
        channelType: 6,
        openState: 3,
        state: 1,
        pageNum: 1,
        pageSize: 1000,
      }).then((res) => {
        const { code, data } = res
        if (code !== 1) return
        this.subAccountOptions = data?.items || []
      })
    },
    handleInitial() {
      this.getSubAccountList()
      this.isAbnormal = false
      this.abnormalData = []
    },
    handlePlanChange() {
      this.formData.planIds = []
      this.tableData = []
      this.getRentPlanList()
    },
    handlePlanIdsChange() {
      this.$refs.multipleTable.clearSelection()
      this.tableData = []
      this.idAndHandelWays = []
      this.ids = []
    },
    cancelHandle(isAbnormal, abnormalData) {
      this.formData = { planIds: [], rentPlanType: '' }
      this.tableData = []
      this.$emit('close', isAbnormal, abnormalData)
      this.isAll = false
    },
    handleOK() {
      if (this.ids.length === 0) {
        this.$message.error('最少选择1条租赁方案')
        return
      }
      if (this.ids.length > 200) {
        this.$message.error('最多选择200条租赁方案')
        return
      }

      let _status = true
      this.tableData.forEach((item) => {
        const ref = `form${item.id}`
        this.$refs[ref].clearValidate()
      })
      this.ids.forEach((item) => {
        const ref = `form${item.id}`
        this.$refs[ref].validate((valid) => {
          if (!valid) {
            _status = false
          }
        })
      })
      if (!_status) return

      this.createItemRentPlanLink({
        itemId: this.planRow.id,
        idAndHandelWays: this.ids.map((item) => ({
          id: item.id,
          accountId: item.accountId,
        })),
      })
    },

    handleAccountChange(accountId, row) {
      this.ids.find((item) => {
        if (item.id === row.id) {
          item.accountId = accountId
          return true
        }
        return false
      })
    },
    handleSelectionChange(rows) {
      this.ids = rows
    },
    handleClear() {
      this.isAll = false
      this.formData.planIds = []
      this.tableData = []
    },
    // 选择全部
    handleSelectAll() {
      if (this.planIds.length === 0) {
        this.$message.error('暂无租赁方案')
        return
      }
      this.isAll = !this.isAll
      if (!this.formData.rentPlanType) {
        this.$message.error('请选择租赁方案类型')
        return
      }

      if (this.isAll) {
        this.formData.planIds = this.planIds.map((item) => item.id)
      } else {
        this.formData.planIds = []
        this.tableData = []
      }
    },
    // 远端搜索
    remoteMethod(val) {
      this.getRentPlanList({ name: val })
    },
    // 获取租赁方案list
    async getRentPlanList(params) {
      if (!this.formData.rentPlanType) {
        this.$message.error('请选择租赁方案类型')
        return
      }
      const [err, _data] = await this.$to(
        getRentPlanListAPi({
          rentPlanType: this.formData.rentPlanType,
          ...params,
        }),
      )
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.$nextTick(() => {
            this.planIds = data || []
          })
        }
      }
    },
    // 创建租赁关系记录
    async createItemRentPlanLink(params) {
      const [err, _data] = await this.$to(
        createItemRentPlanLinkApi({ ...params }),
      )
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (Array.isArray(data) && data.length > 0) {
            this.isAbnormal = true
            this.abnormalData = data
            this.cancelHandle(this.isAbnormal, this.abnormalData)
          } else {
            this.isAbnormal = false
            this.cancelHandle(this.isAbnormal)
            this.$message.success('绑定成功')
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.selectPlan-item {
  align-items: center;
  width: 150px !important;
  height: auto;
  & > div {
    margin-right: 10px;
  }
}
.bindPlan_tips {
  margin-bottom: 20px;
  font-size: 14px;
  & > div {
    margin-bottom: 10px;
    & > span {
      font-weight: 500;
      margin-right: 5px;
    }
  }
}
.selectPlan-container ::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
}
.selectPlan-box {
  width: 60%;
  max-height: 155px;
  overflow-y: auto;
  margin-right: 10px;
  .selectPlan {
    width: 100%;
  }
}

::v-deep(.el-form-item--small.el-form-item) {
  margin-top: 24px;
}

::v-deep(.el-clamp-lines__alone) {
  overflow: visible;
  display: inline-block;
}

.resetopions {
  height: auto;
}
.el-select-dropdown__item {
  height: auto;
}
</style>
